var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.976 7.29883H9.02539V16.8444H14.976V7.29883Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63904 12.0734C9.63831 11.1542 9.85046 10.247 10.2594 9.42023C10.6684 8.59349 11.2635 7.86895 11.9997 7.30144C11.0879 6.59766 9.99291 6.16002 8.83985 6.03854C7.68679 5.91706 6.52219 6.11664 5.47916 6.61447C4.43612 7.1123 3.55673 7.88831 2.9415 8.85378C2.32626 9.81926 2 10.9353 2 12.0742C2 13.2132 2.32626 14.3292 2.9415 15.2947C3.55673 16.2602 4.43612 17.0362 5.47916 17.534C6.52219 18.0319 7.68679 18.2314 8.83985 18.11C9.99291 17.9885 11.0879 17.5508 11.9997 16.847C11.2633 16.2794 10.6681 15.5546 10.2591 14.7275C9.85007 13.9005 9.63805 12.9928 9.63904 12.0734Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 12.0719C21.9996 13.2109 21.6733 14.327 21.0579 15.2925C20.4426 16.258 19.5631 17.034 18.5199 17.5318C17.4767 18.0296 16.312 18.229 15.1589 18.1074C14.0058 17.9857 12.9108 17.5478 11.999 16.8438C12.7349 16.2758 13.3298 15.5511 13.7389 14.7243C14.148 13.8975 14.3606 12.9903 14.3606 12.071C14.3606 11.1518 14.148 10.2446 13.7389 9.41777C13.3298 8.59098 12.7349 7.86625 11.999 7.29824C12.9108 6.59423 14.0058 6.15638 15.1589 6.03472C16.312 5.91307 17.4767 6.11252 18.5199 6.61029C19.5631 7.10805 20.4426 7.88404 21.0579 8.84955C21.6733 9.81506 21.9996 10.9311 21.9996 12.0702V12.0719Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4095 15.8337V15.6381H21.4953V15.5977H21.291V15.6381H21.3717V15.8337H21.4095ZM21.8061 15.8337V15.5977H21.7443L21.6722 15.7663L21.6 15.5977H21.5382V15.8337H21.5829V15.655L21.6498 15.8084H21.6962L21.7631 15.655V15.8337H21.8061Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.65287f029868c51cebcf180f5b901582.svg";
export { ForwardRef as ReactComponent };